import { useTranslation } from "react-i18next";
import {
    Card,
    CardContent,
    CardHeader,
    Divider,
    Typography,
    CardActions,
    InputAdornment,
    Grid
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useEffect, useState } from "react";
import { TextFieldNumber } from "src/_modules/common";
import { ROLES } from "src/constants";
import { set } from "lodash";
import { runJoiValidate } from "src/_utils";
import { ESTIMATION_DAYS_FROM_TO_SCHEMA } from "../ValidationSchemas";

export default function EstimateDaysForDeliveyCard({
    daysOfDelivery,
    onConfirm,
    loading,
    error,
    isSuccess,
    role
}) {
    const { t } = useTranslation();


    const [days, setDays] = useState({
        from: '',
        to: ''
    })

    const handleChange = ({ target: { name, value } }) => {
        setDays((prev) => {
            let clone = { ...prev }
            set(clone, name, value)
            return clone
        })
    }

    useEffect(() => {
        if (!!daysOfDelivery) {
            setDays(daysOfDelivery)
        }
    }, [daysOfDelivery])

    const [validationErrors, setValidationErrors] = useState(null)

    const confirmHandler = () => {
        try {
            setValidationErrors(null)

            let payload = {
                from: days?.from ? Number(days.from) : null,
                to: days?.to ? Number(days.to) : null
            }

            const errors = runJoiValidate(ESTIMATION_DAYS_FROM_TO_SCHEMA, payload)

            if (!!errors) {
                setValidationErrors(errors)
                return
            }

            onConfirm({
                daysOfDelivery: payload
            })

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <Card sx={{ height: "100%", display: 'flex', flexDirection: 'column' }}>
            <CardHeader title={t("Estimated days for delivery to the customer")} />
            <Divider />
            <CardContent sx={{ flex: 1 }}  >
                <Typography sx={{ mt: 2 }}>
                    {`${t("Number of days expected for the shipment to reach the customer from the moment it")} ${role === ROLES.merchant ? t("is created") : t("enters the warehouse")}`}
                </Typography>
                <Grid container spacing={2} justifyContent="space-between" alignItems="center">
                    <Grid item xs={12} sm={6}>
                        <TextFieldNumber
                            decimal={false}
                            label={t("From")}
                            margin="normal"
                            name="from"
                            value={days?.from}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            max={6}
                            fullWidth
                            error={!!validationErrors?.from}
                            helperText={validationErrors?.from ?? ''}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">
                                    {(days == 1) ? t("Day") : t("Days")}
                                </InputAdornment>,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextFieldNumber
                            decimal={false}
                            label={t("To")}
                            margin="normal"
                            name="to"
                            value={days?.to}
                            onChange={handleChange}
                            variant="outlined"
                            size="small"
                            max={7}
                            fullWidth
                            error={!!validationErrors?.to}
                            helperText={validationErrors?.to ?? ''}
                            InputProps={{
                                endAdornment: <InputAdornment position="start">
                                    {(days == 1) ? t("Day") : t("Days")}
                                </InputAdornment>,
                            }}
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row-reverse' }}>
                <LoadingButton
                    variant="contained"
                    disabled={(!days?.from && !!days?.to) || (!!days?.from && !days?.to) || loading}
                    loading={loading}
                    onClick={confirmHandler}
                >{t("Confirm")}
                </LoadingButton>
                {isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {!!error && <Typography color="error">{t(error)}</Typography>}
            </CardActions>
        </Card>
    );
};

